
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provider/[slug]",
      function () {
        return require("private-next-pages/provider/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provider/[slug]"])
      });
    }
  